import {MARKET} from '../config';

export const getCurrency = () => {
    switch (MARKET) {
        case 'cz':
            return 'CZK';
    }

    return 'EUR';
};
